import POPULAR_ALL from '../../../assets/images/filterShortcutButtonLogo/popular_all.svg';
import POPULAR_JOHNDEERE from '../../../assets/images/filterShortcutButtonLogo/popular_johndeere.svg';
import POPULAR_KUBOTA from '../../../assets/images/filterShortcutButtonLogo/popular_kubota.svg';
import UNDER_150PS from '../../../assets/images/filterShortcutButtonLogo/under_150ps.svg';
import { FilterType } from '../../../interfaces/Filter.interfaces';
import { createFilterShortcutUrl } from '../../../utils/filter/createFilterShortcutUrl.util';
import { marketPricePageInfo, pageInfo } from '../../pageInfo/pageInfo.constant';

const TRACTOR_POKING_LIST_PAGE_PATH = pageInfo.tractorPokingListPage.path;
const MARKET_PRICE_LIST_PAGE_PATH = marketPricePageInfo.listPage.path;

const SORT_POKE_COUNT_DESC = 'pokeCount_desc';

const BRAND_JOHNDEERE = '58e2c97b-92c1-43d7-a05a-b99b5432f0d2';
const BRAND_KUBOTA = '885e1ccd-a2b6-45e4-8933-8b6f258c97fd';
const BRAND_DAEDONG = '9ab9fb56-860e-4db2-ba52-31496161f36f';

const PS_MAX_150 = {
  min: 0,
  max: 150,
};

export interface IFilterShortcutButtonInfo {
  logoUrl?: string;
  navigateTo: string;
  title: string;
}

export interface IFilterShortcutConstant {
  filterType: FilterType;
  shortcutButtonInfos: IFilterShortcutButtonInfo[];
}

export const userOwnTractorFilterShortcutInfos: IFilterShortcutConstant = {
  filterType: 'userOwnTractorFilter',
  shortcutButtonInfos: [
    {
      logoUrl: POPULAR_ALL,
      navigateTo: createFilterShortcutUrl(TRACTOR_POKING_LIST_PAGE_PATH, {
        sort: SORT_POKE_COUNT_DESC,
      }),
      title: '인기급상승',
    },
    {
      logoUrl: POPULAR_JOHNDEERE,
      navigateTo: createFilterShortcutUrl(TRACTOR_POKING_LIST_PAGE_PATH, {
        sort: SORT_POKE_COUNT_DESC,
        brand: BRAND_JOHNDEERE,
      }),
      title: '존디어인기순',
    },
    {
      logoUrl: POPULAR_KUBOTA,
      navigateTo: createFilterShortcutUrl(TRACTOR_POKING_LIST_PAGE_PATH, {
        sort: SORT_POKE_COUNT_DESC,
        brand: BRAND_KUBOTA,
      }),
      title: '구보다인기순',
    },
    {
      logoUrl: UNDER_150PS,
      navigateTo: createFilterShortcutUrl(TRACTOR_POKING_LIST_PAGE_PATH, {
        psRange: PS_MAX_150,
      }),
      title: '150마력이하',
    },
  ],
};

export const marketPriceFilterShortcutInfos: IFilterShortcutConstant = {
  filterType: 'marketPriceFilter',
  shortcutButtonInfos: [
    {
      navigateTo: createFilterShortcutUrl(MARKET_PRICE_LIST_PAGE_PATH, {
        brand: BRAND_DAEDONG,
        psRange: {
          min: 50,
          max: 100,
        },
      }),
      title: '가성비로 뜬 ‘대동’ 인기 매물 시세',
    },
    {
      navigateTo: createFilterShortcutUrl(MARKET_PRICE_LIST_PAGE_PATH, {
        brand: BRAND_JOHNDEERE,
        psRange: {
          min: 150,
          max: 300,
        },
      }),
      title: '힘 좋은 ‘밭농사용 매물’ 시세',
    },
    {
      navigateTo: createFilterShortcutUrl(MARKET_PRICE_LIST_PAGE_PATH, {
        priceRange: {
          min: 30000000,
          max: 50000000,
        },
      }),
      title: '3천~5천 ‘효자 매물’ 시세',
    },
    {
      navigateTo: createFilterShortcutUrl(MARKET_PRICE_LIST_PAGE_PATH, {
        priceRange: {
          min: 100000000,
          max: 1000000000,
        },
      }),
      title: '프리미엄 트랙터, 시세 감 잡아보자',
    },
  ],
};
